import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'liebherr-no-data',
    templateUrl: 'no-data.component.html',
    styleUrls: ['no-data.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoDataComponent {
    constructor() {}
}
